var api = require("!../../../../../style-loader/dist/runtime/injectStylesIntoLinkTag.js");
            var content = require("!!../../../../../css-modules-typescript-loader/index.js!../../../../../file-loader/dist/cjs.js??ref--6-2!./splide-default.min.css");

            content = content.__esModule ? content.default : content;

var options = {"injectType":"linkTag"};

options.insert = "head";

var update = api(content, options);



